import styled from 'styled-components';
import Grid from '@klv/utils/grid';
import Typography from '@klv/atoms/typography';
import type { ITransientProps } from '../types';

export const CardContainer = styled.div<{ cardCount: number; }>`
  display: flex;
  gap: 2.4rem;
  min-height: 38rem;
  min-width: ${({ cardCount }) => `calc((33.2rem * ${cardCount}) + (2.4rem * (${cardCount} - 1)))`};
  scroll-snap-type: x proximity;
  white-space: nowrap;
  width: 100%;

  ${({ theme }) => theme.screenSize.s768.mediaQuery} {
    min-height: 50rem;
  }

  ${({ theme }) => theme.screenSize.s1366.mediaQuery} {
    min-height: 58rem;
  }
`;

export const CardContainerWrapper = styled.div`
  display: flex;
  grid-column: 1 / -1;
  overflow-x: auto;
  padding-bottom: ${({ theme }) => theme.globalVerticalPadding};
  position: relative;
`;

export const RelatedContentGrid = styled(Grid)`
  grid-template-rows: auto auto;
  padding-top: ${({ theme }) => theme.globalVerticalPadding};
`;

export const StyledHeadline = styled(Typography)<ITransientProps>`
  color: ${({ $background, theme }) => theme.relatedContent[$background].text};
  grid-column: 1 / -1;
  margin-bottom: 2.4rem;

  ${({ theme }) => theme.screenSize.s768.mediaQuery} {
    margin-bottom: 4rem;
  }

  ${({ theme }) => theme.screenSize.s1024.mediaQuery} {
    margin-bottom: 4.8rem;
  }
`;

export const StyledRelatedContent = styled.div<ITransientProps>`
  background-color: ${({ $background, theme }) => theme.relatedContent[$background].background};
`;
